/* eslint-disable */
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import { fetchGraphQL } from "../../../services/api-raindrop";

import { Size } from "../../../logic/enums.ts";
import RaindropTitle from "../../../ui-components/raindrop-title/raindrop-title.tsx";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";
import RaindropCard, {
  RaindropCardStyle,
} from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import TagElement from "../../../ui-components/tag-element/tag-element.tsx";
import { ORGANISATION_TAGS } from "../../../services/constants.js";
import RaindropClickable from "../../../ui-components/raindrop-clickable/raindrop-clickable.tsx";
import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";
import OrganisationListElement from "../../../ui-components/organisation-list-element/organisation-list-element.tsx";
import ContentSelectPaymentAmount from "../../../ui-components/content-select-payment-amount/content-select-payment-amount.tsx";
import RaindropCardStripe, {
  StripeIntent,
} from "../../../ui-components/raindrop-card-stripe-card/raindrop-card-stripe-card.tsx";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import Sparkle from "../../../ui-components/raindrop-sparkle/raindrop-sparkle.tsx";
import RaindropSparkleCurtain from "../../../ui-components/raindrop-sparkle-curtain/raindrop-sparkle-curtain.tsx";
import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";
import ContributionSlider from "../../../ui-components/contribution-slider/contribution-slider.tsx";
import {
  isLocalEnvironment,
  isProductionEnvironment,
} from "../../../services/environment.js";
import JSONBlob from "../../../ui-components/json-blob/json-blob.tsx";

import RaindropPage from "../../../ui-components/raindrop-page/raindrop-page.tsx";

enum Stage {
  Intro = "Intro",
  SelectCategories = "SelectCategories",
  SelectOrganisations = "SelectOrganisations",
  SelectAmount = "SelectAmount",
  SelectRaindropPlus = "SelectRaindropPlus",
  EnterCardDetails = "EnterCardDetails",
  Complete = "Complete",
}

const ButtonPanel = ({
  isContinueDisabled = false,
  onClickContinue,
  onClickBack,
}) => {
  return (
    <div className="flex flex-row w-full  ">
      <div className="flex flex-row gap-2 w-full">
        <RaindropButton isFluid={true} title="Back" onClick={onClickBack} />
        <RaindropButton
          isFluid={true}
          title="Continue"
          style={ButtonStyle.Primary}
          size={Size.Large}
          isDisabled={isContinueDisabled}
          onClick={onClickContinue}
        />
      </div>
    </div>
  );
};

const StageIntro = ({ stage, onClickContinue, onClickBack }) => {
  if (stage !== Stage.Intro) {
    return null;
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-col items-center  gap-6 justify-center h-full">
        <RaindropSparkleCurtain />
        <RaindropTitle style={ButtonStyle.Primary} size={Size.Medium} />

        <h1 className="font-black text-6xl text-center">
          Let's get you set up
        </h1>
      </div>
      <div className="flex flex-col gap-2 p-4 pb-8">
        <RaindropButton
          size={Size.Large}
          isFluid={true}
          style={ButtonStyle.Primary}
          title="Get started"
          onClick={onClickContinue}
        />
        <RaindropButton
          size={Size.Large}
          isFluid={true}
          style={ButtonStyle.Secondary}
          title="I just want to explore"
          onClick={onClickBack}
        />
      </div>
    </div>
  );
};

const CategoriesList = ({ onClickTag, selectedTags }) => {
  return (
    <div className="flex flex-row flex-wrap items-center  gap-4 ">
      {ORGANISATION_TAGS.map((tag, index) => {
        const isSelected = selectedTags.includes(tag);
        return (
          <RaindropMotionFadeUp className="w-min" key={tag} delay={index * 0.1}>
            <RaindropClickable onClick={() => onClickTag(tag)}>
              <TagElement key={tag} value={tag} isSelected={isSelected} />
            </RaindropClickable>
          </RaindropMotionFadeUp>
        );
      })}
    </div>
  );
};

const StageSelectCategories = ({
  stage,
  onClickTag,
  selectedTags,
  onClickContinue,
  onClickBack,
}) => {
  if (stage !== Stage.SelectCategories) {
    return null;
  }

  return (
    <div className="flex flex-col items-center justify-center h-full w-full">
      <OnboardingSkipButton />
      <div className="flex flex-col items-center justify-center w-full h-full text-center gap-6">
        <div>
          <RaindropTextHeading1>Select causes</RaindropTextHeading1>
          <RaindropTextSubtitle>
            We will recommed you organisations based on your preferences
          </RaindropTextSubtitle>
        </div>
        <CategoriesList onClickTag={onClickTag} selectedTags={selectedTags} />
      </div>
      <ButtonPanel
        isContinueDisabled={selectedTags.length === 0}
        onClickContinue={onClickContinue}
        onClickBack={onClickBack}
      />
    </div>
  );
};

const SuggestedOrganisationsPanel = ({
  onAddNewOrganisation,
  onCancelOrganisation,
  sausageValues,
  setValues = (x) => {},
  selectedTags,
}) => {
  const [inputText, setInputText] = useState("");
  const [organisationObjects, setOrganisationObjects] = useState([]);

  useEffect(() => {
    fetchGraphQL(`
      query {
        retrieveOnboardingOrganisations (
          searchText: "${inputText}"          
          tags: ${JSON.stringify(selectedTags)}
          limit: 3
        ) {  
          id
          name
          presignedUrlLogo
          isHydrated
        }
      }
    `).then((response) => {
      console.log("Response from searchObjects:", response);
      if (response.errors) {
        console.error("Error fetching organisations:", response.errors);
        return;
      }
      setOrganisationObjects(response.data.retrieveOnboardingOrganisations);
    });
  }, [inputText, selectedTags]);

  const onSelectOrganisation = (organisation) => {
    const index = sausageValues.findIndex(
      (value) =>
        (value.organisation && value.organisation.id === organisation.id) ||
        (value.waterfall && value.waterfall.id === organisation.id)
    );
    if (index === -1) {
      return;
    }
    const newValues = [...sausageValues];

    newValues.forEach((value, i) => {
      value.selected = false;
    });
    newValues[index].selected = true;

    setValues(newValues);
  };

  return (
    <div className="flex flex-col items-center justify-center w-full text-center gap-6 s">
      <RaindropCard additionalClasses="w-full gap-4">
        <div className="flex flex-col w-full ">
          <RaindropTextHeading1>Suggested organisations</RaindropTextHeading1>
          <RaindropTextSubtitle>
            Find more organisations in Raindrop
          </RaindropTextSubtitle>
        </div>

        <div className="flex flex-col flex-wrap gap-4 w-full ">
          {organisationObjects.map((organisation, index) => (
            <OrganisationListElement
              key={index}
              onClick={() => onSelectOrganisation(organisation)}
              onAddNewOrganisation={onAddNewOrganisation}
              onCancelOrganisation={onCancelOrganisation}
              organisation={organisation}
              presignedUrl={organisation.presignedUrlLogo}
              name={organisation.name}
              isSupporting={
                sausageValues.find(
                  (value) =>
                    value.organisation?.id === organisation.id ||
                    value.waterfall?.id === organisation.id
                ) !== undefined
              }
            />
          ))}
        </div>
      </RaindropCard>
    </div>
  );
};

const StageSelectOrganisations = ({
  stage,
  selectedTags,
  sausageValues,
  onClickContinue,
  onClickBack,
  onAddNewOrganisation,
  onCancelOrganisation,
  setValues = (x) => {},
}) => {
  if (stage !== Stage.SelectOrganisations) {
    return null;
  }

  const selectedSausageValue = sausageValues.find((value) => value.selected);

  const onSubmit = () => {
    const newValues = sausageValues.map((sausage) => {
      return {
        ...sausage,
        oldValue: sausage.value,
      };
    });
    setValues(newValues);
    onClickContinue();
  };

  return (
    <div className="flex flex-col items-center justify-center h-full w-full">
      <OnboardingSkipButton />

      <div className="flex flex-col h-full w-full overflow-y-auto no-scrollbar pb-6 gap-4">
        <RaindropMotionFadeUp>
          <div className="flex flex-col overflow-y-auto">
            <RaindropCircle
              sausageValues={sausageValues}
              size={"SMALL"}
              isSpringyTransition={false}
            />
          </div>
        </RaindropMotionFadeUp>

        <ContributionSlider
          sausageValue={selectedSausageValue}
          setValues={setValues}
          sausageValues={sausageValues}
          doShowSaveBar={false}
        />

        <RaindropMotionFadeUp delay={0.4}>
          <SuggestedOrganisationsPanel
            onAddNewOrganisation={onAddNewOrganisation}
            onCancelOrganisation={onCancelOrganisation}
            selectedTags={selectedTags}
            sausageValues={sausageValues}
            setValues={setValues}
          />
        </RaindropMotionFadeUp>
      </div>

      <ButtonPanel
        onClickContinue={onSubmit}
        onClickBack={onClickBack}
        isContinueDisabled={sausageValues.length === 0}
      />
    </div>
  );
};

const StageSelectAmount = ({
  stage,
  newSubunits,
  setNewSubunits,
  onClickContinue,
  onClickBack,
}) => {
  if (stage !== Stage.SelectAmount) {
    return null;
  }

  const onSubmit = () => {
    fetchGraphQL(`
      mutation {
        updateAccountPlan(
          subunits: ${newSubunits}
        ) {
          id
        }
      }
    `).then((data) => {
      if (data.errors) {
        console.error("Error updating account plan:", data.errors);
        return;
      }
      onClickContinue();
    });
  };

  return (
    <div className="flex flex-col h-full">
      <OnboardingSkipButton />
      <div className="flex flex-col h-full items-center justify-center w-full gap-4 overflow-y-auto no-scrollbar py-4">
        <RaindropTextHeading1>
          How much would you like to give each month?
        </RaindropTextHeading1>
        <ContentSelectPaymentAmount
          newKindnessAmount={newSubunits}
          setNewKindnessAmount={setNewSubunits}
        />
      </div>
      <ButtonPanel
        onClickContinue={onSubmit}
        onClickBack={onClickBack}
        isContinueDisabled={newSubunits === null}
      />
    </div>
  );
};

const StageSelectRaindropPlus = ({
  stage,
  newSubunits,
  onClickBack,
  onClickContinue,
}) => {
  const [newIsRaindropPlus, setNewIsRaindropPlus] = useState<boolean | null>(
    null
  );

  if (stage !== Stage.SelectRaindropPlus) {
    return null;
  }

  const TickValue = ({ title, isTicked }) => {
    let tailwindIcon = "fas fa-xmark ";
    let tailwindTextOpacity = "opacity-50";

    if (isTicked) {
      tailwindIcon = "fas fa-check text-green-500";
      tailwindTextOpacity = "";
    }

    return (
      <div
        className={`flex flex-row gap-4 font-bold w-full ${tailwindTextOpacity}`}
      >
        <div>
          <i className={tailwindIcon} />
        </div>
        <div>{title}</div>
      </div>
    );
  };

  const onSubmit = () => {
    fetchGraphQL(`
      mutation {
        updateAccountPlan(
          isSupportingRaindrop: ${newIsRaindropPlus}
        ) {
          id
        }
      }
      `).then((resp) => {
      if (resp.errors) {
        console.log(resp);
        return;
      }
      onClickContinue();
    });
  };

  return (
    <div className="flex flex-col h-full gap-4">
      <OnboardingSkipButton />
      <div className="flex flex-col h-full gap-6">
        <RaindropClickable onClick={() => setNewIsRaindropPlus(false)}>
          <RaindropCard isSelected={newIsRaindropPlus === false}>
            <div className="flex flex-col w-full">
              <RaindropTextHeading1>Just Donate</RaindropTextHeading1>
              <RaindropTextSubtitle>
                All of your contributions go to the causes you support
              </RaindropTextSubtitle>
            </div>

            <div className="flex flex-col gap-2 w-full">
              <TickValue
                title={"Support causes that matter to you"}
                isTicked={true}
              />
              <TickValue title={"Connect with friends"} isTicked={true} />
              <TickValue
                title={"Support more than three charities"}
                isTicked={false}
              />
              <TickValue title={"Set a custom theme"} isTicked={false} />
            </div>
          </RaindropCard>
        </RaindropClickable>
        <RaindropClickable onClick={() => setNewIsRaindropPlus(true)}>
          <RaindropCard isSelected={newIsRaindropPlus === true}>
            <div className="flex flex-col w-full">
              <RaindropTextHeading1>Raindrop Plus</RaindropTextHeading1>
              <RaindropTextSubtitle>
                Support us with 10% of your contribution. This will not change
                the amount that leaves your account.
              </RaindropTextSubtitle>
            </div>

            <div className="flex flex-col gap-2 w-full">
              <TickValue
                title={"Support causes that matter to you"}
                isTicked={true}
              />
              <TickValue title={"Connect with friends"} isTicked={true} />
              <TickValue
                title={"Support more than three charities"}
                isTicked={true}
              />
              <TickValue title={"Set a custom theme"} isTicked={true} />
            </div>
          </RaindropCard>
        </RaindropClickable>
      </div>
      <ButtonPanel onClickBack={onClickBack} onClickContinue={onSubmit} />
    </div>
  );
};

const StageEnterCardDetails = ({
  stage,
  newSubunits,
  onClickContinue,
  onClickBack,
}) => {
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    if (stage !== Stage.EnterCardDetails) {
      return;
    }

    fetchGraphQL(`
      mutation {
        stripeCreatePaymentIntent (
          subunits: ${newSubunits}
        )
      }
    `).then((response) => {
      console.log("Response from getAccountPlan:", response);
      if (response.errors) {
        console.error("Error fetching account plan:", response.errors);
        return;
      }
      console.log(
        "Payment intent created:",
        response.data.stripeCreatePaymentIntent
      );
      setClientSecret(response.data.stripeCreatePaymentIntent);
    });
  }, [stage]);

  if (stage !== Stage.EnterCardDetails) {
    return null;
  }

  // if (isLocalEnvironment()) {
  //   // Delete this block, but remember to re-add it.
  //   return (
  //     <div>
  //       <RaindropTextHeading1>Not turned on</RaindropTextHeading1>
  //       RD-9989 This is the local environment.{" "}
  //       <RaindropTextParagraph>
  //         Check the comments here to see how to enable it.
  //       </RaindropTextParagraph>
  //       <RaindropButton title={"Continue on"} onClick={onClickContinue} />{" "}
  //     </div>
  //   );
  // }

  return (
    <div className="flex flex-col h-full">
      <OnboardingSkipButton />
      <div className="flex flex-col h-full items-center justify-center gap-6">
        <RaindropTextHeading1>
          Enter your card details to start giving
        </RaindropTextHeading1>
        <RaindropCardStripe
          stripeClientSecret={clientSecret}
          intent={StripeIntent.PaymentIntent}
          onConfirmCallback={onClickContinue}
          onBackCallback={onClickBack}
        />
      </div>
    </div>
  );
};

const StageComplete = ({
  stage,
  onClickContinue,
  onClickBack,
  sausageValues,

  setShareComponent = (x) => {},
}) => {
  if (stage !== Stage.Complete) {
    return null;
  }

  const ComponentSharecard = ({
    date = new Date(),
    points = -1,
    numberOfQuestions = 10,
    centerElement = null,
  }) => {
    const percentage = Math.floor((100 * points) / numberOfQuestions);
    const dateNumber = date.getDate();
    const dateString = date.toLocaleString("default", { month: "short" });

    const dateStr = "" + dateNumber + " " + dateString;

    let tailwindCardBackground =
      "bg-gradient-to-br from-[#1C1C1E] to-[#2C1A47]";
    // "bg-gradient-to-br from-[#2F2F2F] to-[#2C1A47]";
    // "bg-gradient-to-br from-blue-950 to-red-950";

    return (
      <div className="flex flex-col p-6 bg-color-dark-background-secondary gap-3 w-[300px] h-[400px] relative border border-color-dark-border-primary">
        <div
          className={`flex flex-col  w-[250px] h-[250px] aspect-square  rounded-lg ${tailwindCardBackground}   border-8 border-white  `}
        >
          {centerElement}
        </div>

        <div className="flex h-full w-full flex-col items-center gap-2">
          <RaindropTitle size={Size.Small} style={ButtonStyle.Primary} />
          <h1 className="font-black text-2xl text-color-dark-text-primary text-center">
            I'm a good person
          </h1>
          <p className="flex gap-2 items-center text-xs font-bold text-color-dark-text-secondary">
            <i className="fas fa-link" />
            app.theraindropcompany.com
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col h-full items-center relative">
      <div className="flex flex-col h-full gap-12 items-center pt-4">
        <RaindropMotionFadeUp delay={0.4}>
          <div className="flex flex-col gap-4 w-full max-w-sm ">
            <i className="fas fa-star text-color-raindrop-primary text-4xl text-center" />
            <h1 className="font-black text-4xl text-center">
              You've made your first contribution
            </h1>

            <RaindropTextSubtitle isCentered={true}>
              You one of few people who use their privilege to do good and make
              the world a better place for everyone
            </RaindropTextSubtitle>
          </div>
        </RaindropMotionFadeUp>
        <RaindropMotionFadeUp delay={0.6}>
          <div className="flex flex-col gap-4 relative">
            <ComponentSharecard
              centerElement={
                <RaindropCircle
                  id="circle-complete"
                  sausageValues={sausageValues}
                  size={Size.Small}
                />
              }
            />

            <RaindropButton
              size={Size.Large}
              isFluid={true}
              icon="fas fa-fire"
              title="Share"
              onClick={() => {
                setShareComponent(
                  <ComponentSharecard
                    centerElement={
                      <RaindropCircle
                        id="circle-complete-for-sharing"
                        sausageValues={sausageValues}
                        size={Size.Small}
                      />
                    }
                  />
                );
              }}
            />
          </div>
        </RaindropMotionFadeUp>
      </div>

      <RaindropMotionFadeUp delay={0.8}>
        <FlexCol>
          <RaindropButton
            title="Continue to app"
            onClick={onClickContinue}
            to="/raindrop"
            size={Size.Large}
            isFluid={true}
            style={ButtonStyle.Secondary}
          />
          <RaindropButton
            title="Take the tour"
            to={"/raindrop/tour"}
            size={Size.Large}
            isFluid={true}
            style={ButtonStyle.Primary}
          />
        </FlexCol>
      </RaindropMotionFadeUp>
      <RaindropSparkleCurtain />
    </div>
  );
};

const OnboardingSkipButton = () => {
  const navigate = useNavigate();

  const onClickSkip = () => {
    navigate("/raindrop");
  };

  return (
    <div className="flex flex-row w-full justify-end px-4">
      <RaindropButton
        style={ButtonStyle.Tertiary}
        isFluid={false}
        size={Size.Small}
        title="Skip"
        onClick={onClickSkip}
      />
    </div>
  );
};

const RaindropOnboarding = ({
  userCurrent,
  onAddNewOrganisation,
  onCancelOrganisation,
  setValues = (x) => {},
  sausageValues,
  setShareComponent = (x) => {},
  onResetCircle = () => {},
}) => {
  const navigate = useNavigate();

  const [stage, setStage] = useState(Stage.Intro);

  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [newSubunits, setNewSubunits] = useState(null);

  const onClickTag = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter((t) => t !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  const onClickContinue = () => {
    switch (stage) {
      case Stage.Intro:
        setStage(Stage.SelectCategories);
        break;
      case Stage.SelectCategories:
        setStage(Stage.SelectOrganisations);
        break;
      case Stage.SelectOrganisations:
        setStage(Stage.SelectAmount);
        break;
      case Stage.SelectAmount:
        setStage(Stage.SelectRaindropPlus);
        break;
      case Stage.SelectRaindropPlus:
        setStage(Stage.EnterCardDetails);
        break;
      case Stage.EnterCardDetails:
        setStage(Stage.Complete);
        break;
      case Stage.Complete:
        navigate("/raindrop");
        break;
    }
  };

  const onClickBack = () => {
    switch (stage) {
      case Stage.Intro:
        navigate("/raindrop");
        break;
      case Stage.SelectCategories:
        setStage(Stage.Intro);
        break;
      case Stage.SelectOrganisations:
        setStage(Stage.SelectCategories);
        break;
      case Stage.SelectAmount:
        setStage(Stage.SelectOrganisations);
        break;
      case Stage.SelectRaindropPlus:
        setStage(Stage.SelectAmount);
      case Stage.EnterCardDetails:
        setStage(Stage.SelectRaindropPlus);
        break;
      case Stage.Complete:
        setStage(Stage.EnterCardDetails);
        break;
    }
  };

  useEffect(() => {
    if (!userCurrent) {
      navigate("/raindrop");
    }
  }, [userCurrent]);

  useEffect(() => {
    onResetCircle();
  }, [stage]);

  return (
    <RaindropPage>
      {/* <div className="flex flex-col h-full w-full items-center"> */}
      <div className="flex flex-col h-full w-full max-w-lg p-4">
        <StageIntro
          stage={stage}
          onClickContinue={onClickContinue}
          onClickBack={onClickBack}
        />
        <StageSelectCategories
          stage={stage}
          onClickTag={onClickTag}
          selectedTags={selectedTags}
          onClickContinue={onClickContinue}
          onClickBack={onClickBack}
        />
        <StageSelectOrganisations
          stage={stage}
          sausageValues={sausageValues}
          selectedTags={selectedTags}
          onClickContinue={onClickContinue}
          onClickBack={onClickBack}
          onAddNewOrganisation={onAddNewOrganisation}
          onCancelOrganisation={onCancelOrganisation}
          setValues={setValues}
        />
        <StageSelectAmount
          stage={stage}
          newSubunits={newSubunits}
          setNewSubunits={setNewSubunits}
          onClickContinue={onClickContinue}
          onClickBack={onClickBack}
        />

        <StageSelectRaindropPlus
          stage={stage}
          newSubunits={newSubunits}
          onClickBack={onClickBack}
          onClickContinue={onClickContinue}
        />
        <StageEnterCardDetails
          stage={stage}
          newSubunits={newSubunits}
          onClickContinue={onClickContinue}
          onClickBack={onClickBack}
        />
        <StageComplete
          stage={stage}
          onClickContinue={onClickContinue}
          onClickBack={onClickBack}
          sausageValues={sausageValues}
          setShareComponent={setShareComponent}
        />
      </div>
      {/* </div> */}
    </RaindropPage>
  );
};

export default RaindropOnboarding;
